import React, { useEffect, useState } from "react";
import { Add as AddIcon, Remove as RemoveIcon } from "@mui/icons-material";

import { useDispatch, useSelector } from 'react-redux';
import { useTheme, ThemeProvider, Container, Typography, useMediaQuery, Box, TextField } from "@mui/material";
import { Form, Input, Button, message, Select } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Sidebars from "../../Components/Sidebar/sidebar";
import appColors from "../../config/appColors";
import { postRequest } from "../../Api";
import { apiRoutes } from "../../Api/apiRoutes";
import { setLoader } from "../../Redux/Reducers/gernalSlice";
import { Modal } from 'antd';
import { getDateString } from "../../config/functions";
import MyRichTextEditor from "../../Components/RichTextEditor";
import { VEH_AGREEMENT_URL } from "../../Api/constants";
const { Option } = Select;

// Document list items
const documentItems = [
    { key: 'pco_license_front', label: 'PCO License Front' },
    { key: 'pco_license_back', label: 'PCO License Back' },
    { key: 'driving_license_front', label: 'Driving License Front' },
    { key: 'driving_license_back', label: 'Driving License Back' },
    { key: 'proof_of_address', label: 'Proof of Address' },
    { key: 'pco_license_paper', label: 'PCO License Paper' },
];


const UserDetails = () => {



    const { id } = useParams();

    const navigate = useNavigate();
    const theme = useTheme();
    const dispatch = useDispatch();

    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm')); // Adjust breakpoint as needed
    const user = useSelector((state) => state.authReducer.user);

    const [vehicle, setVehicle] = useState([]);
    const [reports, setReports] = useState();
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [isAddNote, setIsAddNote] = useState('');
    const [customerNotes, setCustomerNotes] = useState([]);

    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // ≤600px
    const isTablet = useMediaQuery(theme.breakpoints.only('sm')); // 600–900px

    const history = useNavigate();

    const getCustomerDetails = async () => {
        const onSuccess = (res) => {
            console.log('res', res);

            setVehicle(res.data);
            setReports(res.reports);
            dispatch(setLoader(false));
        }
        const onError = (err) => {
            console.log('err', err)
            err?.data?.error && alert(err.data.error);
            dispatch(setLoader(false));
        }

        const body = {
            cust_id: id,
            token: user?.token
        }
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.getCustDetails, onSuccess, onError);


    }

    const moveTrash = async () => {
        setConfirmDelete(false);
        const onSuccess = (res) => {
            console.log('res', res);
            history('/vehicles');
            dispatch(setLoader(false));
        }
        const onError = (err) => {
            console.log('err', err)
            err?.data?.error && message.error(err.data.error);
            dispatch(setLoader(false));
        }

        const body = {
            veh_id: id,
            token: user?.token
        }
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.moveVehicleToTrash, onSuccess, onError);

    }


    const saveNote = async (value) => {

        const onSuccess = (res) => {
            setIsAddNote(false);
            setCustomerNotes(res.customer_notes)
            message.success('Note saved!');
        }
        const onError = (err) => {
            dispatch(setLoader(false));
            message.error('Failed to save note');
            console.log('err', err)
        }
        const body = {
            token: user?.token,
            cust_id: id,
            note: JSON.stringify(value),
        }
        console.log('body', body)
        if (!body.note) return message.error('Please add note');
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.addCustomerNotes, onSuccess, onError);


    }

    const getCustomerNotes = async (value) => {

        const onSuccess = (res) => {

            setCustomerNotes(res.data);
            dispatch(setLoader(false));
        }

        const onError = (err) => {
            dispatch(setLoader(false));
            message.error('Failed to get notes');
        }
        const body = {
            token: user?.token,
            cust_id: id,
        }
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.getCustomerNotes, onSuccess, onError);
    }


    const updateNote = async (value, note_id, cb) => {

        const onSuccess = () => {
            dispatch(setLoader(false));
            message.success('Note saved!');
            // navigate(`/agreement-notes/${ids.id}`);
            cb();
        }
        const onError = (err) => {
            dispatch(setLoader(false));
            message.error('Failed to save note');
            console.log('err', err)
        }
        const body = {
            token: user?.token,
            note_id: note_id,
            note: JSON.stringify(value),
        }
        console.log('body', body)
        if (!body.note) return message.error('Please add note');
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.updateCustomerNote, onSuccess, onError);


    }

    const deleteNote = async (note_id) => {

        const onSuccess = (res) => {
            dispatch(setLoader(false));
            message.success('Note deleted!');
            setCustomerNotes(res.customer_notes)

        }
        const onError = (err) => {
            dispatch(setLoader(false));
            message.error('Failed to delete note');
            console.log('err', err)
        }
        const body = {
            token: user?.token,
            note_id: note_id,
            cust_id: id
        }
        dispatch(setLoader(true));
        await postRequest(body, apiRoutes.deleteCustomerNote, onSuccess, onError);


    }






    useEffect(() => {
        getCustomerDetails();
        getCustomerNotes();
    }, [])

    const RenderAgreements = React.useCallback(
        () => {
            {
                return customerNotes?.map((v, i) => {
                    return (
                        <div style={{ width: "100%", }}>
                            <Typography style={{ color: appColors.black, fontSize: 16, fontFamily: 'Poppins', marginLeft: 10, marginTop: 20 }}>Created at: {new Date(v.created_at).toLocaleString()}</Typography>

                            <MyRichTextEditor
                                disabled={true}
                                val={v.note}
                                data={v}
                                edit={true}
                                del={true}
                                onSave={(value, cb = () => { }) => updateNote(value, v.cn_id, cb)}
                                onDelete={() => deleteNote(v.cn_id)}
                            />
                        </div>
                    )
                })
            }
        },
        [customerNotes],
    )

    const StatCard = ({ title, value }) => (
        <Box
            sx={{
                bgcolor: 'white',
                borderRadius: 2,
                overflow: 'hidden',
                boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
                textAlign: 'center',
            }}
        >
            <Box sx={{ bgcolor: appColors.primaryLight, py: 1.5 }}>
                <Typography variant="subtitle2" sx={{ color: 'white', fontWeight: 600, fontFamily: 'Poppins' }}>
                    {title}
                </Typography>
            </Box>
            <Box sx={{ py: 2.5 }}>
                <Typography variant="h6" sx={{ fontWeight: 700, fontFamily: 'Poppins' }}>
                    {value}
                </Typography>
            </Box>
        </Box>
    );
    const InfoRow = ({ label, value, fullWidth = false }) => (
        <Box sx={{ display: fullWidth ? 'block' : 'flex', flexDirection: 'column' }}>
            <Typography variant="caption" color="text.secondary" sx={fieldText}>
                {label}
            </Typography>
            <Typography variant="body2" sx={valueText}>
                {value || '—'}
            </Typography>
        </Box>
    );

    const DocumentCard = ({ label, url }) => (
        <Box
            onClick={() => window.open(url, '_blank')}
            sx={{
                p: 2.5,
                bgcolor: '#fafafa',
                borderRadius: 2,
                border: '1px solid #e0e0e0',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: 'pointer',
                transition: 'all 0.15s',
                '&:hover': {
                    bgcolor: '#f5f5f5',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                },
            }}
        >
            <Typography sx={{ fontWeight: 500,fontFamily:'Poppins' }}>{label}</Typography>
            <Button type="link" size="small">
                Open →
            </Button>
        </Box>
    );
    return (
        <>
            <ThemeProvider theme={theme}>
                <div style={{ display: 'flex', minHeight: '100vh' }}>
                    {/* Sidebar - hide on mobile or make it collapsible */}
                    <Sidebars />

                    {/* Main content - takes full width on mobile */}
                    <Box
                        component="main"
                        sx={{
                            flexGrow: 1,
                            p: { xs: 2, sm: 3 },
                            width: '100%',
                            maxWidth: '100%',
                            boxSizing: 'border-box',
                        }}
                    >
                        {/* Header */}
                        <Typography
                            variant="h5"
                            component="h1"
                            className="headertext"
                            sx={{
                                mb: 3,
                                fontWeight: 600,
                                color: appColors.primary,
                                fontFamily: 'Poppins'
                            }}
                        >
                            Customer Details
                        </Typography>

                        {/* Stats cards - become stacked on mobile */}
                        <Box
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: {
                                    xs: '1fr',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                },
                                gap: 2,
                                mb: 4,
                            }}
                        >
                            <StatCard
                                title="Total Agreements"
                                value={reports?.total_agreements ?? '-'}
                            />
                            <StatCard
                                title="Paid / Total Invoices"
                                value={`${reports?.total_paid_amount ?? '-'} / ${reports?.total_invoice_amount ?? '-'}`}
                            />
                            <StatCard
                                title="Total Rented cars"
                                value={reports?.total_rented_persons ?? '-'}
                            />
                        </Box>

                        {/* Customer Info Card */}
                        <Box
                            sx={{
                                bgcolor: 'white',
                                borderRadius: 2,
                                p: 3,
                                mb: 4,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                            }}
                        >
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                <Typography variant="h6" sx={{ color: appColors.primary, fontFamily: 'Poppins', fontWeight: '800' }}>
                                    Personal Information
                                </Typography>

                                <Box sx={{ display: 'flex', gap: 1.5 }}>
                                    <Button
                                        variant="outlined"
                                        size={isMobile ? "small" : "medium"}
                                        onClick={() => navigate(`/edit-user/${id}`)}
                                    >
                                        Edit
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        size={isMobile ? "small" : "medium"}
                                        onClick={() => navigate(`/customer-history/${id}`)}
                                    >
                                        See Report
                                    </Button>
                                </Box>
                            </Box>

                            <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                                    gap: { xs: 2, sm: 3 },
                                    rowGap: 1.5,
                                }}
                            >
                                <InfoRow label="Name" value={vehicle?.name} />
                                <InfoRow label="Email" value={vehicle?.email} />
                                <InfoRow label="Phone" value={vehicle?.phone} />
                                <InfoRow label="Alternate Phone" value={vehicle?.alternate_phone} />
                                <InfoRow label="License number" value={vehicle?.license_number} />
                                <InfoRow label="License exp date" value={getDateString(vehicle?.license_exp_date)} />
                                <InfoRow label="Created at" value={getDateString(vehicle?.created_at)} />
                                <InfoRow label="Postal code" value={vehicle?.postal_code} />
                                <InfoRow label="Date of birth" value={getDateString(vehicle?.dob)} />
                                <InfoRow fullWidth label="Address" value={vehicle?.address} />
                                <InfoRow label="Next of kin name" value={vehicle?.kins_name} />
                                <InfoRow label="Kins phone" value={vehicle?.kins_phone} />
                                <InfoRow label="Kins email" value={vehicle?.kins_email} />
                                <InfoRow label="Kins relation" value={vehicle?.kins_relation} />
                                <InfoRow fullWidth label="Kins Address" value={vehicle?.kins_address} />
                            </Box>
                        </Box>

                        {/* Notes Section */}
                        <Box
                            sx={{
                                bgcolor: 'white',
                                borderRadius: 2,
                                overflow: 'hidden',
                                mb: 4,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                            }}
                        >
                            <Box
                                sx={{
                                    bgcolor: appColors.primary,
                                    color: 'white',
                                    p: 2,
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                }}
                            >
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                    Notes
                                </Typography>

                                <Button
                                    variant="contained"
                                    size="small"
                                    sx={{ bgcolor: 'white', color: appColors.primary, '&:hover': { bgcolor: '#f0f0f0' } }}
                                    startIcon={isAddNote ? <RemoveIcon /> : <AddIcon />}
                                    onClick={() => setIsAddNote(!isAddNote)}
                                >
                                    {isAddNote ? 'Close' : 'Add Note'}
                                </Button>
                            </Box>

                            {isAddNote && (
                                <Box sx={{ p: 3, borderTop: `1px solid ${appColors.grey}` }}>
                                    <Typography variant="subtitle1" gutterBottom>
                                        Add new note
                                    </Typography>
                                    <MyRichTextEditor
                                        submitButtonText="Add note"
                                        onSave={saveNote}
                                    />
                                </Box>
                            )}

                            {customerNotes?.length === 0 && !isAddNote && (
                                <Box sx={{ p: 4, textAlign: 'center', color: 'text.secondary' }}>
                                    You have no notes for this customer yet
                                </Box>
                            )}

                            {customerNotes?.map((note) => (
                                <Box
                                    key={note.cn_id}
                                    sx={{
                                        p: 3,
                                        borderTop: `1px solid ${appColors.grey}`,
                                        '&:first-of-type': { borderTop: 'none' },
                                    }}
                                >
                                    <Typography variant="caption" color="text.secondary" gutterBottom>
                                        {new Date(note.created_at).toLocaleString()}
                                    </Typography>

                                    <MyRichTextEditor
                                        disabled={true}
                                        val={note.note}
                                        data={note}
                                        edit={true}
                                        del={true}
                                        onSave={(value, cb) => updateNote(value, note.cn_id, cb)}
                                        onDelete={() => deleteNote(note.cn_id)}
                                    />
                                </Box>
                            ))}
                        </Box>

                        {/* Documents Section */}
                        <Box>
                            <Typography variant="h6" sx={{ mb: 2, color: appColors.primary, fontWeight: 600,fontFamily:'Poppins' }}>
                                Customer Documents
                            </Typography>

                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                                {documentItems.map((doc) =>
                                    vehicle?.[doc.key] ? (
                                        <DocumentCard
                                            key={doc.key}
                                            label={doc.label}
                                            url={`${VEH_AGREEMENT_URL}${vehicle[doc.key]}`}
                                        />
                                    ) : null
                                )}
                            </Box>
                        </Box>
                    </Box>
                </div>

                {/* Delete Confirmation Modal */}
                <Modal
                    title="Are you sure you want to delete this vehicle?"
                    open={confirmDelete}
                    onCancel={() => setConfirmDelete(false)}
                    footer={[
                        <Button key="cancel" onClick={() => setConfirmDelete(false)}>
                            Cancel
                        </Button>,
                        <Button danger key="delete" onClick={moveTrash}>
                            Delete
                        </Button>,
                    ]}
                />
            </ThemeProvider>
        </>
    )

}

const infoContainer = {
    width: 250, borderRadius: 10, backgroundColor: appColors.white, padding: 5, paddingBottom: 20
}

const infoHeadingContainer = {
    width: "100%", backgroundColor: appColors.primaryLight,
    borderTopRightRadius: 10, borderTopLeftRadius: 10,
    height: 40, alignItems: 'center', justifyContent: 'center', display: 'flex'
}

const infoHeading = {
    fontSize: 12, color: appColors.white, fontFamily: 'Poppins', fontWeight: 600
}

const infoValueContainer = {
    display: 'flex', alignItems: 'center', justifyContent: 'center', width: "100%", marginTop: 15,
}

const infoValue = {
    fontSize: 14, color: appColors.black, fontFamily: 'Poppins', fontWeight: 600,
}

const vehicleRowContainer = {
    borderStyle: 'dashed', borderTop: 'none', borderRight: 'none', borderLeft: 'none', borderColor: appColors.grey,
    display: 'flex', flexDirection: 'row', width: "100%", justifyContent: 'space-between', height: 'auto',
    marginTop: 5, paddingBottom: 3

}

const vehicleRow1 = {
    display: 'flex', flexDirection: 'row', width: '48%', justifyContent: 'space-between',
}

const vehicleRow2 = {
    display: 'flex', flexDirection: 'row', width: '48%', justifyContent: 'space-between',
}

const fieldText = {
    fontSize: 12, color: appColors.black, fontFamily: 'Poppins', fontWeight: 600,
}

const valueText = {
    fontSize: 12, color: appColors.greyText, fontFamily: 'Poppins', fontWeight: 600,
}

export default UserDetails
